/* ============================================================
   Alice Lane — Insider Program page redesign
   - Smooth-scrolls hero "Sign Up" CTA to the signup form
   - Phone country-code select (flag / dial code swap)
   - Submits the signup form to Klaviyo's client API when a
     Klaviyo company ID + list ID are configured on the section;
     otherwise the native Shopify customer form submit is used.
   ============================================================ */
(function () {
  'use strict';

  function initScrollLinks(scope) {
    (scope || document).querySelectorAll('[data-insider-scroll]').forEach(function (link) {
      if (link.dataset.insiderScrollBound) return;
      link.dataset.insiderScrollBound = '1';
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        var hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#')) : '';
        if (!hash || hash === '#') return;
        var target = document.querySelector(hash);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initCountrySelect(form) {
    var country = form.querySelector('.insider-signup--country');
    if (!country) return;
    var select = country.querySelector('select');
    var codeEl = country.querySelector('.insider-signup--country-code');
    if (!select) return;
    var sync = function () {
      var code = select.value || '+1';
      country.dataset.code = code;
      if (codeEl) codeEl.textContent = code;
    };
    select.addEventListener('change', sync);
    sync();
  }

  function showMessage(form, state, text) {
    var el = form.querySelector('.insider-signup--message');
    if (!el) return;
    el.dataset.state = state;
    el.textContent = text;
  }

  function buildKlaviyoPayload(form, listId) {
    var get = function (name) {
      var field = form.querySelector('[data-insider-field="' + name + '"]');
      return field ? field.value.trim() : '';
    };
    var dial = (form.querySelector('.insider-signup--country select') || {}).value || '+1';
    var rawPhone = get('phone').replace(/[^0-9]/g, '');
    var phone = rawPhone ? dial + rawPhone : '';
    var smsConsent = !!(form.querySelector('[data-insider-field="sms-consent"]') || {}).checked;

    var attributes = {
      email: get('email'),
      first_name: get('first-name'),
      last_name: get('last-name')
    };
    if (phone) attributes.phone_number = phone;

    var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (phone && smsConsent) {
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Insider Program Page',
          profile: {
            data: {
              type: 'profile',
              attributes: Object.assign({}, attributes, { subscriptions: subscriptions })
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
  }

  function initSignupForm(root) {
    var form = root.querySelector('.insider-signup--form');
    if (!form || form.dataset.insiderBound) return;
    form.dataset.insiderBound = '1';

    initCountrySelect(form);

    var companyId = (root.dataset.klaviyoCompany || '').trim();
    var listId = (root.dataset.klaviyoList || '').trim();
    if (!companyId || !listId) return; // native Shopify customer form submit

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = (form.querySelector('[data-insider-field="email"]') || {}).value || '';
      if (!email.trim()) {
        showMessage(form, 'error', 'Please enter your email address.');
        return;
      }

      form.classList.add('is-submitting');
      showMessage(form, '', '');

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2025-04-15'
        },
        body: JSON.stringify(buildKlaviyoPayload(form, listId))
      })
        .then(function (response) {
          if (response.ok || response.status === 202) {
            form.reset();
            var sync = form.querySelector('.insider-signup--country select');
            if (sync) sync.dispatchEvent(new Event('change'));
            showMessage(form, 'success', root.dataset.successMessage || "You're in! Welcome to the Insider Program.");
          } else {
            return response.json().catch(function () { return {}; }).then(function (body) {
              var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
              showMessage(form, 'error', detail || 'Something went wrong. Please try again.');
            });
          }
        })
        .catch(function () {
          showMessage(form, 'error', 'Something went wrong. Please check your connection and try again.');
        })
        .finally(function () {
          form.classList.remove('is-submitting');
        });
    });
  }

  function initAll(scope) {
    initScrollLinks(scope || document);
    (scope || document).querySelectorAll('.insider-signup--root').forEach(initSignupForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
